(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["da-season-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('da-season-carousel')) {
  customElements.define('da-season-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.viewport = this.querySelector('.da-carousel__viewport');
      this.track = this.querySelector('.da-carousel__track');
      this.group = this.querySelector('.da-carousel__group');
      this.toggle = this.querySelector('[data-pause]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.clones = [];
      if (this.group.children.length > 1) {
        for (let n = 0; n < 2; n++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
          this.track.append(clone);
          this.clones.push(clone);
        }
      } else this.paused = true;
      this.measure = () => {this.width = this.group.getBoundingClientRect().width; if (this.clones.length) this.viewport.scrollLeft = this.width;};
      this.resize = new ResizeObserver(this.measure);
      this.resize.observe(this.viewport);
      this.visible = true;
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;});
      this.observer.observe(this);
      this.updateButton = () => {this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel; this.toggle.setAttribute('aria-pressed', String(this.paused));};
      this.stop = () => {this.paused = true; this.updateButton();};
      this.toggle.addEventListener('click', () => {this.paused = !this.paused; this.updateButton();}, opts);
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.stop();
        if (!this.group.firstElementChild) return;
        const step = this.group.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.group).gap);
        this.viewport.scrollBy({left: Number(button.dataset.step) * step, behavior: this.motion.matches ? 'instant' : 'smooth'});
      }, opts));
      this.viewport.addEventListener('pointerdown', this.stop, opts);
      this.viewport.addEventListener('wheel', this.stop, {...opts, passive:true});
      this.viewport.addEventListener('keydown', this.stop, opts);
      this.viewport.addEventListener('scroll', () => {
        if (!this.width || !this.clones.length) return;
        if (this.viewport.scrollLeft < 1) this.viewport.scrollLeft += this.width;
        else if (this.viewport.scrollLeft >= this.width * 2) this.viewport.scrollLeft -= this.width;
      }, {...opts, passive:true});
      this.addEventListener('mouseenter', () => {this.hovered = true;}, opts);
      this.addEventListener('mouseleave', () => {this.hovered = false;}, opts);
      this.addEventListener('focusin', () => {this.focused = true;}, opts);
      this.addEventListener('focusout', event => {this.focused = this.contains(event.relatedTarget);}, opts);
      this.motion.addEventListener('change', () => {if (this.motion.matches) this.stop();}, opts);
      this.updateButton();
      this.measure();
      const frame = time => {
        const delta = Math.min(time - (this.lastTime || time), 50);
        this.lastTime = time;
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden && this.width) {
          this.scrollCarry = (this.scrollCarry || 0) + delta * Number(this.dataset.speed || 30) / 1000;
          const amount = Math.floor(this.scrollCarry);
          if (amount) {this.viewport.scrollLeft -= amount; this.scrollCarry -= amount;}
        }
        this.frameId = requestAnimationFrame(frame);
      };
      this.frameId = requestAnimationFrame(frame);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frameId);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.clones?.forEach(clone => clone.remove());
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
